export const RULES_ID = 'js-check-in-rules';